
import { Options, Vue } from 'vue-class-component'
import Rating from 'primevue/rating'

@Options({
  components: {
    Rating,
  },
})
export default class Skills extends Vue {
  php = 4
  nodejs = 5
  mysql = 4
  mongo = 2
  linux = 4
  js = 5
  nest = 3
  ts = 4
  nuxt = 4
  vue = 5
  seo = 4
  ws = 5
  angular = 1
  react = 2
  wp = 4

  get average(): string {
    return (this.score / 15).toFixed(2)
  }

  get score(): number {
    return (
      this.php +
      this.nodejs +
      this.mysql +
      this.mongo +
      this.linux +
      this.js +
      this.nest +
      this.ts +
      this.nuxt +
      this.vue +
      this.seo +
      this.ws +
      this.angular +
      this.react +
      this.wp
    )
  }
}
